export default "ui-currency[layout='result']{font:var(--ui-font-headline-medium);color:var(--ui-color-orange-text)}\n";